const { connect } = require('react-redux');
const { context } = require('app-context');
const ChangeRoleDialog = require('../components/ChangeRoleDialog');

const selectors = context.selectors.all;
const actions   = context.actions;

module.exports = connect(
    (state) => ({
        schoolRoles: selectors.getSchoolRoles(state)
    }),
    {
        onSubmit: actions.communication.changeUserRole
    }
)(ChangeRoleDialog);
